export default __webpack_public_path__ + "static/media/cunningstrike3.62360671.png";